var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3325(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.645,
    height: 75,
    viewBox: "0 0 37.645 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4295",
    "data-name": "Path 4295",
    d: "M.146,0c-.371.211.095,75.42,0,75a37.5,37.5,0,0,0,0-75Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(5.8 25.53)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M11.537,22.727l2.447-2.462-9.077-8.9,9.085-8.911L11.533,0,0,11.359Z",
    transform: "translate(0 0)",
    fill: "#3a3a3a",
    opacity: 0.69
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3325);
export default __webpack_public_path__ + "static/media/Group 3325.01b9d8c2ecad3994537d71f27e8175bf.svg";
export { ForwardRef as ReactComponent };